export default __webpack_public_path__ + "static/media/User_icon_2.13c36d52.svg";